/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycWorkflowEventDto } from '../../models/kyc-workflow-event-dto';

export interface GetTimeline$Params {
  id: string;
}

export function getTimeline(http: HttpClient, rootUrl: string, params: GetTimeline$Params, context?: HttpContext): Observable<StrictHttpResponse<KycWorkflowEventDto>> {
  const rb = new RequestBuilder(rootUrl, getTimeline.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycWorkflowEventDto>;
    })
  );
}

getTimeline.PATH = '/kyc/processes/{id}/timeline';
